'use strict';

var _require = require('./baseProperties'),
    baseProperties = _require.baseProperties;

module.exports.PubIdentTypSchema = {
  title: 'PubIdentTyp',
  type: 'object',
  properties: Object.assign({}, baseProperties)
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/schema/pubIdentTyp.js
// module id = MIcX
// module chunks = 0